import Vue from 'vue'
import Store from 'store'

export default {
    // 默认
    "default": {
        isShowTitle: true, // 是否显示标题栏
        isShowMarket: true, // 是否显示贷款导流页
        isShowLogout: true, // 是否显示退出登录
        isShowDownload: false, // 是否显示下载入口, -1不显示，管制所有入口
        skin: "", // 皮肤
        client: "h5", // 对接端类型
        locale: "default", // lang.js的key
        creditFlow: "APR" // 进件流程
    },
    "idumiao119021": {
        isShowTitle: true, // 是否显示标题栏
        isShowMarket: true, // 是否显示贷款导流页
        isShowLogout: true, // 是否显示退出登录
        isShowDownload: false, // 是否显示下载入口, -1不显示，管制所有入口
        skin: "", // 皮肤
        client: "h5", // 对接端类型
        locale: "default", // lang.js的key
        creditFlow: "APR" // 进件流程
    },
    // 航班
    "idmiao633": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: true,
        isShowDownload: false,
        skin: "hangbanguanjia",
        client: "app",
        locale: "hangban",
        creditFlow: "APR"
    },
    // 新浪
    "idmiao634": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: true,
        isShowDownload: true,
        skin: "sina",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 美图
    "idmiao635": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: true,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "meitu",
        creditFlow: "IRR36"
    },
    // 金山
    "idmiao637": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 转转
    "idmiao638": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 哈啰
    "idmiao644": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    "idmiao645": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 洋钱罐
    "idmiao646": {
        isShowTitle: false,
        isShowMarket: true,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 车轮
    "idmiao647": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 环球黑卡
    "idmiao648": {
        isShowTitle: false,
        isShowMarket: true,
        isShowLogout: false,
        isShowDownload: true,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 爱奇艺
    "idmiao650": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "aiqiyi",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    "idmiao651": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "aiqiyi",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    "idmiao652": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "aiqiyi",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // 同程
    "idmiao653": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    "idmiao654": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: false,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },
    // OPPO
    "idmiao655": {
        isShowTitle: false,
        isShowMarket: false,
        isShowLogout: true,
        isShowDownload: false,
        skin: "",
        client: "app",
        locale: "default",
        creditFlow: "IRR36"
    },

    getChannel(partner) {
        return Store.get("dm_channel_conf_" + partner) || this[partner] || null
    },

    checkValid(partner) {
        if (!partner || typeof partner !== "string" || !this.getChannel(partner)) {
            return false
        }

        return true
    },

    getQueryVariable(variable) {
        let query = window.location.search.substring(1)
        let vars = query.split("&")

        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=")
            if (pair[0] == variable) {
                return pair[1]
            }
        }
        return ""
    },

    // 获取渠道皮肤，主要用于公共页面
    getChannelSkin() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return Vue.cookie("skin") || this[channel].skin
    },
    // 获取渠道标题文案配置key，对应文件lang.js的key
    getChannelLocale() {
        let channel = Vue.cookie("partner") || this.getQueryVariable("partner") || ""
        let locale = (channel && this[channel]) ? this[channel].locale : "default"

        return locale || "default"
    },
    // 是否是APP渠道，默认不是
    isAppChannel() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return ((this.getChannel(channel)).client === "app")
    },
    // 是否是DMAPP渠道，默认不是
    isAppChannelForDM() {
        if (Vue.cookie("skin") && ["dumiao", "yunxinIOS"].indexOf(Vue.cookie("skin")) > -1) {
            return true
        }
        if (Vue.cookie("applyID")) {
            return true
        }
        return false
    },
    // 是否是IRR36进件流程，默认不是
    isIRR36Channel() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return ((this.getChannel(channel)).creditFlow === "IRR36")
    },
    // 隐藏标题，默认显示
    isHiddenTitle() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        let ua = window.navigator.userAgent.toLowerCase();
        if (channel === "idumiao119021" && ua.indexOf('micromessenger') > -1) {
            return true
        }

        if (Vue.cookie("skin") && ["dumiao", "yunxinIOS"].indexOf(Vue.cookie("skin")) > -1) {
            return true
        }

        return !(this.getChannel(channel).isShowTitle)

    },
    // 显示贷款导流页，默认不显示
    isShowMarket() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return (this.getChannel(channel)).isShowMarket
    },
    // 隐藏退出，默认显示
    isHiddenLogout() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return !((this.getChannel(channel)).isShowLogout)
    },
    // 是否显示下载入口，默认显示
    isDownloadChannel() {
        let channel = Vue.cookie("partner") || ""

        if (!this.checkValid(channel)) {
            channel = "idumiao119021"
        }

        return (this.getChannel(channel)).isShowDownload
    },
    // 获取合同
    getProtocols(page) {
        let channel = Vue.cookie("partner") || ""
        let defaultChannel = "idumiao119021"

        if (!this.checkValid(channel)) {
            channel = defaultChannel || "idumiao119021"
        }

        const positionMap = {
            "apply_bank": 1,
            "valid_bank": 1,
            "daoliu_bank": 1,
            "user_auto": 1,
            "login_index": 4,
            "extension_index": 2,
            "daoliu_sign": 2
        }

        if (this.getChannel(channel) &&
            (this.getChannel(channel)).contractDescs &&
            (this.getChannel(channel)).contractDescs.length > 0) {
            const contracts = (this.getChannel(channel)).contractDescs
            const contractArr = contracts.filter((item) => {
                if (item.contractPosition == positionMap[page]) {
                    item.contractDesc = item.contractDesc.replace("读秒", "")
                    return true
                }
            })
            return contractArr && contractArr.length > 0 ? contractArr : null
        } else if (this.getChannel(defaultChannel) &&
            (this.getChannel(defaultChannel)).contractDescs &&
            (this.getChannel(defaultChannel)).contractDescs.length > 0) {
            const contracts = (this.getChannel(defaultChannel)).contractDescs
            const contractArr = contracts.filter((item) => {
                if (item.contractPosition == positionMap[page]) {
                    item.contractDesc = item.contractDesc.replace("读秒", "")
                    return true
                }
            })
            return contractArr && contractArr.length > 0 ? contractArr : null
        }

        return null
    },
}

// doc
// cookie: partner - 合作方，对应请求接口header的channel
//         channel - 合作方来源，对应请求接口header的channel2
//         portal - 合作方组，对应请求接口header的portal
// store: token - 登录后的access_key，请求接口header的jm-authorization